import Nav from "@/components/Nav";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Introducing from "@/components/Introducing";
import Features from "@/components/Features";
import HowItWorks from "@/components/HowItWorks";
import AppPreview from "@/components/AppPreview";
import Waitlist from "@/components/Waitlist";
import Footer from "@/components/Footer";

export default function Home() {
    return (
        <main className="bg-white text-slate-950">
            <Nav />
            <Hero />
            <Marquee />
            <Introducing />
            <Features />
            <HowItWorks />
            <AppPreview />
            <Waitlist />
            <Footer />
        </main>
    );
}
